import { render, staticRenderFns } from "./SearchAdPreview.vue?vue&type=template&id=580b2bba&scoped=true"
import script from "./SearchAdPreview.vue?vue&type=script&lang=js"
export * from "./SearchAdPreview.vue?vue&type=script&lang=js"
import style0 from "./SearchAdPreview.vue?vue&type=style&index=0&id=580b2bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b2bba",
  null
  
)

export default component.exports